import React, { useEffect, useState } from 'react';
import { onModifiersLoad } from '../../store/Modifiers/actions';
import { useDispatch, useSelector } from 'react-redux';
import { onDishAddModifier, onModifierUpdate } from '../../store/Dish/actions';
import { useTranslation } from 'react-i18next';
import { ModifierCategoriesModal } from './ModifierCategoriesModal';
import { ModifierCategoryItems } from './ModifierCategoryItems';
import Loading from '../../components/Loading';
import { useParams } from 'react-router';
import Button from '../../components/Button/Button';

const ModifierCategories = ({ dish, loading, formik }) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const { catId, dishId } = useParams();
    const [visible, setVisible] = useState(false);
    const [localModifiers, setLocalModifiers] = useState([]);

    const { modifiers } = useSelector(({ modifiers }) => ({
        modif_loading: modifiers.loading,
        modifiers: modifiers.modifiers,
    }));

    const isAllDisabled = !!dish?.archived_at || loading;

    const onShow = () => setVisible(true);
    const onClose = () => {
        setLocalModifiers(formik.values.modifier_groups);
        setVisible(false);
    };
    const onSave = () => {
        formik.setFieldValue("modifier_groups", localModifiers );
        setVisible(false);
    };

    useEffect(() => {
        dispatch(onModifiersLoad());
    }, []);

    useEffect(() => {
        if(dish && dishId) {
            setLocalModifiers(dish.modifier_groups)
        }
    }, [dish]);

    return (
        <Loading loading={loading}>
            <div className="min-h-[50vh] flex flex-col">
                <div className="m-5 py-3 font-medium text-sm" style={{ display: formik.values.modifier_groups?.length ? 'none' : 'flex' }}>
                    <img src="/menuicon/info.svg" alt="info" width={20} height={20} className="mr-1.5" />
                    {t('Add modifier groups (for example, Sides) and modifier items (for example, Fries) to allow your customers to customise their orders.')}
                </div>

                <div className="mx-5 pt-5 pb-4">
                    <button type="button" onClick={onShow} className="inline-flex justify-center py-1.5 px-14 border border-transparent shadow-sm text-sm font-bold rounded-lg text-white bg-gray-900 hover:bg-gray-700 focus:outline-none">
                        {formik.values.modifier_groups?.length ? t('Edit Modifiers') : t('Add Modifier Group')}
                    </button>
                </div>

                {formik.values.modifier_groups?.map((category) => (
                    <div key={category.id}>
                        <ModifierCategoryItems category={category} />
                    </div>
                ))}
                <div className="mt-auto ml-4 mb-4">
                    <Button
                        type="link"
                        color="bg-gray-300"
                        isUpperCase={false}
                        to={`/chain/menu/${catId}/items`}
                        disabled={isAllDisabled}
                        className="h-9 inline-flex justify-center py-1.5 px-5 border border-transparent shadow-sm text-sm font-bold rounded-lg bg-gray-100 hover:bg-gray-200 focus:outline-none"
                    >
                        {t("Cancel")}
                    </Button>
                    <Button
                        type="submit"
                        isUpperCase={false}
                        isLoading={loading}
                        disabled={isAllDisabled}
                        className="h-9 inline-flex justify-center py-1.5 px-6 ml-2 border border-transparent shadow-sm text-sm font-medium rounded-lg text-white bg-gray-900 hover:bg-gray-700 focus:outline-none"
                    >
                        {t("Save")}
                    </Button>
                </div>

                <ModifierCategoriesModal visible={visible} onClose={onClose} onSave={onSave} setLocalModifiers={setLocalModifiers} localModifiers={localModifiers} modifiers={modifiers?.data || []} loading={loading} />
            </div>
        </Loading>
    );
};

export default ModifierCategories;
